<!-- 
  开关组件
  props:
    value: 绑定值
    onText: 展开时文字
    offText: 关闭时文字
    onColor: 开关颜色
  emit: 
    change: 提交开关的状态变化  测试
 -->
 
<template>
  <label class="switch">
    <span :class="{active: !value}">{{onText}}</span>
    <span :class="{active: value}">{{offText}}</span>
    <input
      type="checkbox"
      @change="handleChange"
      class="switch-input"
      v-model="_value"
      :name="name">
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    onText: {
      type: String,
      default: '已归档'
    },
    offText: {
      type: String,
      default: '未归档'
    },
    onColor: {
      type: String,
      default: '#ff7c35'
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    hasText () {
      /* istanbul ignore next */
      return this.onText || this.offText
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange (event) {
      this.$emit('change', event.currentTarget.checked)
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .switch {
    display: inline-block;
    font-size: 0;
    border-radius: 2px;
    overflow: hidden;
    cursor: pointer;
    span {
      display: inline-block;
      font-size: 13px;
      padding: 8px 10px;
      background-color: @bg-lightblue;
      color: @light-gray;
      &.active {
        background-color: @bg-orange;
        color: #fff;
      }
    }
    .switch-input {
      width: 0;
      height: 0;
      display: inline-block;
      overflow: hidden;
      opacity: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// switch.vue?ed0c6d9e